import { Component, QueryList, ViewChildren } from '@angular/core';
import { TABLAACTIVOSCOTIZACIONES, tablaActivosCotizaciones } from '../../../../../shared/data/tables/tabla-activos-cotizaciones';
import { NgbdSortableHeader, SortEvent } from '../../../../../shared/directives/NgbdSortableHeader';
import { TableService } from '../../../../../shared/services/table-activos-cotizaciones';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-cerradas-cotizaciones',
  templateUrl: './cerradas-cotizaciones.component.html',
  styleUrls: ['./cerradas-cotizaciones.component.scss']
})
export class CerradasCotizacionesComponent {

  public selected = [];
  public tableItem$: Observable<tablaActivosCotizaciones[]>;
  public filteredTableItems: tablaActivosCotizaciones[] = [];
  public searchText = '';  // Campo de búsqueda
  total$: Observable<number>;

  constructor(public service: TableService) {
    this.tableItem$ = service.tableItem$;
    this.total$ = service.total$;
    this.service.setUserData(TABLAACTIVOSCOTIZACIONES);
    this.filteredTableItems = TABLAACTIVOSCOTIZACIONES;  // Inicializa con todos los datos
  }

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  onSort({ column, direction }: SortEvent) {
    // Reseteando otros encabezados
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.service.sortColumn = column;
    this.service.sortDirection = direction;
  }

  ngOnInit() {}

  // Método para filtrar por múltiples campos
  filterByMultipleFields() {
    const searchTerm = this.searchText.toLowerCase();
    this.filteredTableItems = TABLAACTIVOSCOTIZACIONES.filter(item =>
      item.id.toLowerCase().includes(searchTerm) ||
      item.Vrtotal?.toLowerCase().includes(searchTerm) ||
      item.Telefono?.toLowerCase().includes(searchTerm) ||
      item.NumeroCotizacion.toLowerCase().includes(searchTerm) ||
      item.Fecha?.toLowerCase().includes(searchTerm) ||
      item.Estado.toLowerCase().includes(searchTerm) ||
      item.Email.toLowerCase().includes(searchTerm) ||
      item.Documento.toLowerCase().includes(searchTerm) ||
      item.Direccion.toLowerCase().includes(searchTerm) ||
      item.Cliente.toLowerCase().includes(searchTerm) 
    );
  }

  // Función de eliminación
  deleteData(id: number) {
    this.tableItem$.subscribe((data: any) => {
      data.map((elem: any, i: any) => { 
        if (elem.id === id) {
          data.splice(i, 1);
        }
      });
    });
  }

}
